import React from 'react';
import { G, Line, Rect, Text as SvgText } from 'react-native-svg';
import { DT } from '../tokens';

type Props = {
  x: number; y: number; width: number; height: number;
  label?: string;
  /** Gap in the bottom wall for a door/opening (ΔP diagrams) */
  doorGap?: number;
  /** Position of the door gap along bottom wall (0–1, default 0.5) */
  doorPos?: number;
};

/** Room outline. Optional door gap in bottom wall for pressurization diagrams. */
export function RoomBox({ x, y, width, height, label, doorGap, doorPos = 0.5 }: Props) {
  const gapStart = doorGap ? x + width * doorPos - doorGap / 2 : 0;
  const gapEnd = doorGap ? gapStart + doorGap : 0;

  return (
    <G>
      {/* Top wall */}
      <Line x1={x} y1={y} x2={x + width} y2={y} stroke={DT.stroke} strokeWidth="2" />
      {/* Left wall */}
      <Line x1={x} y1={y} x2={x} y2={y + height} stroke={DT.stroke} strokeWidth="2" />
      {/* Right wall */}
      <Line x1={x + width} y1={y} x2={x + width} y2={y + height} stroke={DT.stroke} strokeWidth="2" />
      {/* Bottom wall with optional door gap */}
      {doorGap ? (
        <>
          <Line x1={x} y1={y + height} x2={gapStart} y2={y + height} stroke={DT.stroke} strokeWidth="2" />
          <Line x1={gapEnd} y1={y + height} x2={x + width} y2={y + height} stroke={DT.stroke} strokeWidth="2" />
        </>
      ) : (
        <Line x1={x} y1={y + height} x2={x + width} y2={y + height} stroke={DT.stroke} strokeWidth="2" />
      )}
      {/* Room fill */}
      <Rect x={x} y={y} width={width} height={height} fill={DT.fill} opacity={0.6} />
      {label ? (
        <SvgText x={x + width / 2} y={y + height / 2 + 5} fill={DT.desc} fontSize="11"
          fontFamily={DT.sans} textAnchor="middle">{label}</SvgText>
      ) : null}
    </G>
  );
}
